<template>
  <div class="wrap">
    <div
      class="header-wrap"
      :style="{ backgroundImage: `url(${headerImg})` }"
    />
    <div class="select-wrap">
      <template v-if="cardList.length > 0">
        <div class="select-title">请选择VIP卡档位</div>
        <div
          class="select-item"
          v-for="item in cardList"
          :key="item.createdTime"
        >
          <div class="select-item-content">
            <div class="select-item-content-title">{{ item.card_name }}</div>
            <div class="select-item-content-desc">
              节省总金额 ¥{{ item.total_value }}
            </div>
          </div>
          <div class="select-item-action" @click="handleToSelectCard(item)">
            选择此卡
          </div>
        </div>
      </template>
      <div class="select-empty" v-else>
        <van-image :src="require('@/assets/images/empty.png')" class="img" />
        <div class="empty-value">暂无订单</div>
      </div>
    </div>
    <div class="footer">
      <div class="service-time">
        <p>
          客服电话：
          <a href="tel:400-150-9669">400-150-9669</a
          ><span>(每日7:00-21:00)</span>
        </p>
      </div>
    </div>
    <MoreCardLogin
      :value="showMoreCardLogin"
      @close="showMoreCardLogin = $event"
      @handleLogin="handleLogin"
    />
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";
import Vue from "vue";

import { useRouter, useStore, useRoute } from "@/components/use/base";
import { getAllCardList } from "@/apis/home";

import MoreCardLogin from "./MoreCardLogin.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    MoreCardLogin,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const route = useRoute();

    const cardList = ref([]);
    const showMoreCardLogin = ref(false);

    const isLogin = computed(() => !!store.state.token);

    const headerImg = computed(() => {
      const namespaceGroup = route.query.namespace_group;
      return {
        xinxiaoniu:
          "https://common-h5-dev.xiangshuheika.com/static/upload/20260402dac177a22450e.png",
        zhongji:
          "https://common-h5-dev.xiangshuheika.com/static/upload/202603258c80dda805e0b.jpg",
      }[namespaceGroup];
    });

    onMounted(async () => {
      await initData();
    });

    const handleToSelectCard = async (item) => {
      store.commit("changeState", {
        token: item.user_token,
        namespace: item.namespace,
      });
      await store.dispatch("fetchUserInfo");
      await store.dispatch("initProjectData");
      router.push(
        `/index?user_token=${item.user_token}&namespace=${item.namespace}`
      );
    };

    const handleLogin = () => {
      initData();
    };

    const initData = async () => {
      if (!isLogin.value) {
        showMoreCardLogin.value = true;
      } else {
        const loading = vm.$loading();
        try {
          const { data } = await getAllCardList();
          cardList.value = data.cards;
        } finally {
          loading.clear();
        }
      }
    };

    const handleToOrder = () => {
      router.push("/order");
    };

    const handleToService = () => {
      router.push("/service");
    };

    return {
      showMoreCardLogin,
      isLogin,
      cardList,
      headerImg,
      handleToOrder,
      handleToService,
      handleToSelectCard,
      handleLogin,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  min-height: 100vh;
  background-color: #fff;
}

.header-wrap {
  width: 375px;
  height: 168px;
  // background-image: url("https://common-h5-dev.xiangshuheika.com/static/upload/202603258c80dda805e0b.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.select-wrap {
  padding-top: 16px;
  .select-title {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    text-align: center;
    margin-block: 16px;
  }

  .select-item {
    height: 79px;
    background: #fef5f1;
    border-radius: 8px;
    margin: 0 12px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .select-item-content {
      margin-left: 16px;

      .select-item-content-title {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        line-height: 22px;
      }

      .select-item-content-desc {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 16px;
        margin-top: 9px;
      }
    }

    .select-item-action {
      width: 70px;
      height: 24px;
      background: linear-gradient(
        134deg,
        #483122 0%,
        rgba(18, 0, 0, 0.87) 100%
      );
      border-radius: 13px;
      font-weight: 500;
      font-size: 12px;
      color: #f0dbbc;
      line-height: 24px;
      text-align: center;
      margin-right: 19px;
    }
  }

  .select-empty {
    margin-top: 37px;
    .img {
      width: 164px;
      height: 151px;
      display: block;
      margin: 0 auto;
    }
    .empty-value {
      margin-top: 19px;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      line-height: 16px;
      text-align: center;
    }
  }
}

.footer {
  margin-top: 24px;
  padding: 20px 12px;

  .footer-content {
    height: 32px;
    background: #f8f8f8;
    border-radius: 8px;
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #333333;
  }
  .svg-icon {
    font-size: 20px;
    margin-right: 9px;
  }

  .service {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .service-time {
    font-weight: 400;
    font-size: 10px;
    color: #666666;
    line-height: 14px;
    text-align: center;
    margin-top: 12px;
    a {
      color: #0170fe;
    }
    p {
      span {
        margin-left: 8px;
        color: #666666;
      }
    }
  }
}
</style>
